import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import RouteFallback from "./RouteFallback";

function AppLayout() {
  return (
    <>
      <Nav />
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
      <Footer />
    </>
  );
}

export default AppLayout;
